import React from 'react';

const CookiePolicy = () => {
    return (
        <div className="max-w-4xl mx-auto p-6 text-gray-800">
            <h1 className="text-2xl font-bold mb-4">Cookie саясаты</h1>

            <p className="mb-4">
                Бұл Cookie саясаты біздің веб-сайтымызға кіргенде автоматты түрде жиналатын cookie файлдары туралы ақпаратты түсіндіреді. Біз cookie файлдарын қолданушыларға ыңғайлырақ қызмет көрсету үшін қолданамыз.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-2">1. Cookie деген не?</h2>
            <p className="mb-4">
                Cookie - бұл сіздің құрылғыңызда немесе браузеріңізде сақталатын шағын мәтіндік файлдар. Олар сіздің веб-сайтта әрекет етуіңізді және қалауларыңызды есте сақтауға көмектеседі, осылайша сіз сайтты келесі рет қолданған кезде тәжірибеңізді жақсартады.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-2">2. Қандай cookie файлдары қолданылады?</h2>
            <p className="mb-4">
                Біз екі түрлі cookie файлдарын қолданамыз:
                <ul className="list-disc pl-6">
                    <li><strong>Сессия cookie файлдары</strong>: Бұл cookie файлдары тек сіз веб-сайтта бар кезде ғана қолданылады. Олар сессияны аяқтаған кезде өшіріледі.</li>
                    <li><strong>Тұрақты cookie файлдары</strong>: Бұл cookie файлдары бірнеше сессиялар бойы сақталады және келесі рет кіргенде веб-сайттың қызметтерін жеңілдетеді.</li>
                </ul>
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-2">3. Cookie файлдары қалай пайдаланылады?</h2>
            <p className="mb-4">
                Біз cookie файлдарын келесі мақсаттарда қолданамыз:
                <ul className="list-disc pl-6">
                    <li>Қолданушының сайттағы әрекеттерін оңтайландыру және талдау жасау.</li>
                    <li>Сайтқа қайта кіргенде бұрынғы қалауларыңызды сақтау.</li>
                    <li>Пайдаланушының аутентификациясы үшін және сайттың функционалдық қызметтерін қамтамасыз ету үшін.</li>
                </ul>
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-2">4. Cookie файлдарын қалай басқаруға болады?</h2>
            <p className="mb-4">
                Егер сіз cookie файлдарын басқарғыңыз келсе, браузеріңіздің баптауларында cookie файлдарын өшіруге немесе басқаруға болады. Дегенмен, кейбір cookie файлдарын өшірген жағдайда, сайттың кейбір мүмкіндіктері дұрыс жұмыс істемеуі мүмкін.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-2">5. Cookie саясатындағы өзгерістер</h2>
            <p className="mb-4">
                Біз бұл cookie саясатын уақыт өте келе жаңартып отыруымыз мүмкін. Барлық өзгерістер осы бетте жарияланады және жаңартылған дата көрсетіледі.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-2">6. Байланыс</h2>
            <p>
                Егер сізде осы cookie саясаты туралы сұрақтар болса, бізге <a href="mailto:musaaldanazarov@gmail.com" className="text-blue-600 underline">musaaldanazarov@gmail.com</a> мекенжайына хат жолдаңыз.
            </p>
        </div>
    );
};

export default CookiePolicy;